import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import paths from './paths'

Vue.use(VueRouter)

// Create a new router
const router = new VueRouter({
  mode: 'history',
  hash: false,
  // base: process.env.BASE_URL,
  routes: paths,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)

  // Check if page is public
  let authRequired = !to.meta.public || false

  if (authRequired) {
    if (localStorage.getItem('x-token') == null) {
      next({
        name: 'login'
      })
    } else {
      let user = JSON.parse(localStorage.getItem('user'))

      if (user.role !== '1') {
        if (user.role === '2') {
          if (to.meta.clientAuth === true) {
            next()
          } else {
            next({
              path: '/clients/' + user.client,
              params: { clientId: user.client }
            })
          }
        }

        if (user.role === '3') {
          if (to.meta.merchantAuth === true) {
            next()
          } else {
            next({
              path: '/merchants/' + user.merchant,
              params: { clientId: user.merchant }
            })
          }
        } else {
          next()
        }

        if (user.role === '4') {
          if (to.meta.npoAuth === true) {
            next()
          } else {
            next({
              path: '/npos/' + user.npo,
              params: { npoId: user.npo }
            })
          }
        } else {
          next()
        }

      } else {
        next()
      }
    }
    next()
  } else {
    next()
  }
})
export default router
